// extracted by mini-css-extract-plugin
export var colorSquare = "_o5-0";
export var danger = "_o5-5";
export var lightPink = "_o5-8";
export var neutralBlue = "_o5-7";
export var neutralYellow = "_o5-6";
export var normal = "_o5-1";
export var primary = "_o5-2";
export var primaryLight = "_o5-3";
export var solidBlack = "_o5-g";
export var solidGreen = "_o5-b";
export var solidLightBlue = "_o5-d";
export var solidNavy = "_o5-c";
export var solidOrange = "_o5-f";
export var solidPink = "_o5-e";
export var solidRed = "_o5-9";
export var solidYellow = "_o5-a";
export var success = "_o5-4";